const namedEntities: Record<string, string> = {
  amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ',
  ndash: '–', mdash: '—', hellip: '…', lsquo: '‘', rsquo: '’',
  ldquo: '“', rdquo: '”', bull: '•', copy: '©', times: '×',
};

export function decodeEntities(value: string): string {
  return value.replace(/&(#x[\da-f]+|#\d+|[a-z]+);/gi, (entity, key: string) => {
    if (!key.startsWith('#')) return namedEntities[key.toLowerCase()] ?? entity;
    const point = key[1].toLowerCase() === 'x'
      ? parseInt(key.slice(2), 16)
      : parseInt(key.slice(1), 10);
    return point > 0 && point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff)
      ? String.fromCodePoint(point)
      : entity;
  });
}

export function plainText(value?: string): string {
  let text = value || '';
  // Strip actual rich-text markup, preserving literal programming tokens like
  // Rc<T>, <div>, and <span> in plain-text interview question titles.
  if (/<\/(?:p|div|span|strong|em|h[1-6]|li|pre|code|a)>|<br\s*\/?\s*>/i.test(text)) {
    text = text
      .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, '')
      .replace(/<\/?(?:p|div|span|strong|em|b|i|h[1-6]|ul|ol|li|pre|code|a|img|br|blockquote|table|thead|tbody|tr|th|td)\b[^>]*>/gi, ' ');
  }
  return decodeEntities(text).replace(/\s+/g, ' ').trim();
}

